import { render, staticRenderFns } from "./FinanceModuleChart.vue?vue&type=template&id=66080aba&scoped=true"
import script from "./FinanceModuleChart.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceModuleChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FinanceModuleChart.vue?vue&type=style&index=0&id=66080aba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66080aba",
  null
  
)

export default component.exports